var exports = {
  "i": "xaee3c4fa--bf9d20--wrapper",
  "O": "xaee3c4fa--bf9d20--popover-wrapper",
};

module.exports = exports;
